'use es6';

import { useState } from 'react';
import I18n from 'I18n';
import HomepageLabelledInput from '../components/HomepageLabelledInput';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UrlPattern from 'PatternValidationJS/patterns/Url';
import InputUtil from '../util/InputUtil';
import { navigateTo } from '../util/History';
import { TESTS } from '../constants/Paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPageForm = () => {
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [ignoreValidity, setIgnoreValidity] = useState(true);
  const isWebsiteValid = () => {
    return UrlPattern.test(websiteUrl);
  };
  const buttonClicked = event => {
    // Don't ignore validity anymore
    setIgnoreValidity(false);
    if (isWebsiteValid()) {
      const parsedWebsiteUrl = InputUtil.parseWebsiteUrl(websiteUrl);
      // Go to the results page
      navigateTo(`${TESTS}/${parsedWebsiteUrl}`);
    }
    event.preventDefault();
    return false;
  };
  const handleSubmit = event => {
    event.preventDefault();
    return false;
  };
  const getButtonKey = () => {
    return 'error.form.button';
  };
  return /*#__PURE__*/_jsxs("form", {
    className: "website-input",
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(HomepageLabelledInput, {
      type: "url",
      errorText: I18n.text('error.form.website.errorText'),
      labelText: I18n.text('error.form.website.text'),
      onChange: event => {
        const {
          value
        } = event.target;
        setWebsiteUrl(value);
      },
      onBlur: event => {
        const {
          value
        } = event.target;
        setWebsiteUrl(value.trim());
      },
      value: websiteUrl,
      isValid: () => ignoreValidity || isWebsiteValid()
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("button", {
      className: "button primary",
      type: "submit",
      onClick: buttonClicked,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: getButtonKey()
      })
    })]
  });
};
export default ErrorPageForm;